export const remotehost =
  process.env.NODE_ENV !== 'production'
    ? 'http://192.168.0.199:3500'
    : 'https://panel.hotelcleanapp.com';

export const localhost =
  process.env.NODE_ENV !== 'production'
    ? 'http://192.168.0.199:3000'
    : 'https://panel.hotelcleanapp.com';



// WEBPACK FOOTER //
// ./src/host.js